import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { StateService } from "../../../core/providers/state/state.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'vsf-search-entry-component',
  template: `
    <ng-container *ngIf="(storeInfo$ | async) as storeInfo">
      <div class="mt-6 mb-4">
        <vsf-product-list
          [channelId]="storeInfo?.sellerChannel?.id">
        </vsf-product-list>
      </div>
    </ng-container>
  `
})
export class SearchEntryComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    storeInfo$: Observable<any>;

    constructor(private stateService: StateService) {}

    ngOnInit() {
      this.storeInfo$ = this.stateService.select(state => state.storeInfo)
      .pipe(takeUntil(this.destroy$));
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }
}